module.exports = __webpack_public_path__ + "img/arrow-up-from-dotted-line.8f09257d.svg";